import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Mirador } from 'src/app/models/mirador';
import { MiradorCustomList } from 'src/app/models/mirador-custom-list';
import { MiradorList } from 'src/app/models/mirador-list';
import { ListManagerService } from 'src/app/services/list-manager.service';
import { MiradoresService } from 'src/app/services/miradores.service';
import { LinkManagerService } from 'src/app/services/link-manager.service';
import { OrganizerService } from 'src/app/services/organizer.service';

@Component({
  selector: 'app-horizontal-list-sites',
  templateUrl: './horizontal-list-sites.component.html',
  styleUrls: [
    './styles/user-profile.page.scss',
    './styles/user-profile.shell.scss',
    './styles/user-profile.ios.scss',
    './styles/user-profile.md.scss',
  ],
})
export class HorizontalListSitesComponent implements OnInit {

  @Input() title: string;
  @Input() description?: string;
  @Input() miradorList: MiradorList;
  @Input() urlCollection: string;
  
  constructor(public MIService: MiradoresService,
    private router: Router,
    private linkManager: LinkManagerService) { }

  ngOnInit() {

  }

  generateAndOpenDinamikLink(path) {
    const dinamikLink = this.linkManager.generateDinamicLink(path);
    window.open(dinamikLink, '_self')
  }

  seeDetail(mirador: Mirador) {
    const miradorNameNormalize = this.MIService.getNormalizedMiradorNameForURL(mirador.name);
    if (this.linkManager.isMobileWeb()) {
      this.generateAndOpenDinamikLink('mirador/' + miradorNameNormalize);
    } else {
      console.log("utm_source: app");
      this.router.navigate(['/mirador', miradorNameNormalize], {
        queryParams: { utm_source: 'app' }
      });
    }
  }


}
